<div
    class="dropdown-container"
    #container
    (click)="openSelect()"
    [class.dropdownOpen]="displayList"
    [class.itemSelected]="unitModel">
    <input [value]="unitModel ? unitModel.name : ('device-list.unit.dropdown.placeholder' | translate)" readonly />
    <mat-icon class="arrow-icon" svgIcon="dropdown-arrow" [class.openContent]="displayList" />
    <ng-container *ngIf="displayList">
        <div
            class="select-list-container"
            [ngStyle]="{
                width: optionsWidth,
                top: optionsTop,
                left: optionsLeft,
            }"
            #dropdownElement>
            <div *ngFor="let model of modelOptions" class="item" (click)="selectModel(model)">
                {{ model.name }}
            </div>
        </div>
    </ng-container>
</div>
